import OrderSummarySteppedSkeleton from './OrderSummarySteppedSkeleton';

export default OrderSummarySteppedSkeleton;
